export const getCustomerTagList = state => {
    return state.list
}

export const getCustomerTagDataProps = state => {
    return state.props
}


// WEBPACK FOOTER //
// ./src/store/modules/customerTag/getters.js